'use client'
import { Match } from "@/app/pwa/components/match/Match";
import { Match as IMatch } from "@/sources/kicker-amateur/types";
import { getGroupedGamesByKickoff } from "@/sources/kicker-amateur/utils/game";
import { formatDateStyleFull } from "@/utils/datetimeUtils";
import React from "react";
import { NoContentPlain } from "../../components/NoContent";
import { useUpdateQueryParams } from "@/hooks/useUpdateQueryParams";
import { CardHeader } from "../../components/Card";
import { TabBarTabButton } from "../../components/TabBar";

type ScheduleState = "actual" | "history";

function getTeamNameFlags(match: IMatch, clubTeamIds: Record<number, boolean>) {
  return {
    forcedATeamName: clubTeamIds[match.ATeamId!],
    forcedBTeamName: clubTeamIds[match.BTeamId!],
  };
}

interface ClubScheduleProps {
  scheduleState: string;
  schedule: IMatch[];
  clubTeamIds: Record<number, boolean>;
}

export function ClubSchedule({
  scheduleState,
  schedule,
  clubTeamIds,
}: ClubScheduleProps) {
  const groupedSchedule = getGroupedGamesByKickoff(schedule)

  const days = (scheduleState === "history") ? Object.keys(groupedSchedule).reverse() : Object.keys(groupedSchedule);
  const teamIds = Object.keys(clubTeamIds).map(item => parseInt(item))


  const { updateQueryParam } = useUpdateQueryParams();

  const handleScheduleStateChange = (value: ScheduleState) => {
    updateQueryParam('schedule', value.toString())
  };

  return (
    <>
      <CardHeader className="pb-0">
        <div className="flex justify-between items-baseline">
          <h3 className="font-bold text-lg flex-1">Spiele</h3>
          <div>
            <TabBarTabButton
              isActive={scheduleState === "actual"}
              onClick={() => handleScheduleStateChange("actual")}
            >
              <div className="pb-1">Aktuelle <span className="hidden xs:inline">Spiele</span></div>
            </TabBarTabButton>
            <TabBarTabButton
              isActive={scheduleState === "history"}
              onClick={() => handleScheduleStateChange("history")}
            >
              <div className="pb-1">Vergangene <span className="hidden xs:inline">Spiele</span></div>
            </TabBarTabButton>
          </div>
          <div className="flex-1 hidden @sm/card:block"></div>
        </div>
      </CardHeader>
      <div className="p-4">
        <div>
          {days.length > 0 ? (
            <div>
              {days.map((day) => {
                return (
                  <div className="pt-6 border-t border-gray-150 first:border-t-0 first:pt-3 pb-6" key={day}>
                    <h4 className="text-center font-bold">
                      {formatDateStyleFull(day)}
                    </h4>
                    {groupedSchedule[day].games.map((match) => {
                      const teamId = teamIds.find((item) => item == match.ATeamId) ? match.ATeamId : match.BTeamId
                      return (<Match
                        className="p-2 px-4 mt-1"
                        key={`ClubTeamSchedule-${teamId}-${match?.Id}`}
                        match={match}
                        teamId={teamId!}
                        showBigIcons
                        {...getTeamNameFlags(match, clubTeamIds)}
                      />)
                      })}
                  </div>
                );
              })}
            </div>
          ) : (
            <NoContentPlain>Keine Spiele</NoContentPlain>
          )}
        </div>
      </div>
    </>
  );
}
